import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="py-1 font-titleFont flex gap-20"
    >
      <div>
        <div className="py-14 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2021-2024</p>
          <h2 className="text-4xl font-bold">Competitions</h2>
        </div>
        <div className="mt-3 w-full h-[1600px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="AI Innovator Award 2024"
            subTitle="Carnegie Mellon University & KMITL, DELL"
            result="WINNER"
            des="A competition that invites participants to showcase Artificial Intelligence to create innovative business solutions."
          />
          <ResumeCard
            title="Ford Innovator Challenge 2024"
            subTitle="Ford Thailand, NIA, PDA"
            result="MERIT"
            des="Developed innovation and implemented a streamlined process for gathering business in real-world community."
          />
          <ResumeCard
            title="The InnoQuest Challenge"
            subTitle="Siam, SCBx, Bitkub, Techsauce, Fastwork"
            result="TOP 10"
            des="An Innovation-Business Challenge for Global Thai Talents to Ideate, Create, and Real-Elevate."
          />
          <ResumeCard
            title="The 16th Global Student Innovation Challenge (gSIC2023)"
            subTitle="I-create Asia & NSTDA"
            result="MERIT"
            des="An International competition inspiring students to develop innovative solutions for disabilities and the elderly."
          />
            <ResumeCard
            title="The Student Innovation Challenge Thailand"
            subTitle="A-MED, NSTDA"
            result="WINNER"
            des="An annual competition to finalize Thailand representative team for attending gSIC."
          />
            <ResumeCard
            title="CUD Hackathon Thailand"
            subTitle="Chulalongkorn University Demonstration Secondary School"
            result="MERIT"
            des="A design competition for students to create innovative solutions to challenges."
          />
        </div>
      </div>
      <div>
        <div className="py-14 font-titleFont flex flex-col gap-4">
        </div>
        <div className="mt-3 w-full h-[1600px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="The 24th National Software Contest (NSC)"
            subTitle="NSTDA"
            result="2nd National winner"
            des="Thailand National competition for students to develop software and showcase their skills."
          />
          <ResumeCard
            title="WWDC Student challenge"
            subTitle="Apple.inc"
            result="SUBMITTED"
            des="A program that gives up to 350 students and STEM organization members the opportunity to attend Apple's Worldwide Developers Conference (WWDC)"
          />
            <ResumeCard
                title="Capital Market Case Competition (CMCC)"
                subTitle="Investment Banking Club, SET"
                result="Round 1"
                des="A competition to create fundraising and M&A strategies for Thailand’s capital market growth."
            />
        <ResumeCard
            title="I-NEW GEN : Thailand New Gen Inventors 2022"
            subTitle="NSTDA"
            result="WINNER"
            des="A program that encourages young people to use their creativity to develop innovative and useful inventions."
          />
        <ResumeCard
            title="FIRST Tech Challenge Thailand 2021-2022"
            subTitle="FIRST Tech"
            result="Popular Vote Award"
            des="Robotics competition that takes place in a different country each year."
          />

        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;